

import colors from "../../utils/colors";
import { createUseStyles } from 'react-jss';

var styles = {
  wrapper: {
    marginTop: '1rem'
  },
  input: {
    width: '2rem',
    height: '2rem',
    margin: {
      right: '0.9rem'
    },
    verticalAlign: 'middle',
    cursor: 'pointer'
  },
  labelText: function labelText(props) {return {
      font: {
        family: ['Lato', 'sans-serif'],
        lineHeight: '2.4rem',
        size: '1.6rem'
      },
      letterSpacing: '0.02rem',
      verticalAlign: 'middle',
      color: props.highlightColor || colors.neutral[900],
      cursor: 'pointer'
    };},
  disabled: {
    cursor: 'not-allowed'
  },
  validationBlock: {
    font: {
      size: '1.2rem',
      lineHeight: '1.8rem'
    },
    letterSpacing: '0.02rem',
    color: colors.blue[600],
    display: 'flex',
    alignItems: 'center',
    margin: {
      left: '0.1rem',
      top: '0.4rem',
      right: '0rem',
      bottom: '0rem'
    }
  },
  validationMessage: {
    marginLeft: '0.4rem'
  },
  radioGuideline: { maxWidth: '100%' }
};
var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map